import { useEffect } from 'react';
import { reactEvents, EntityVisitedEvent } from '@bridge/reactEvents';
import { useLocalStorage } from '@texas/hooks/useLocalStorage';

const STORAGE_KEY = 'texas_entity_history';
const MAX_ENTRIES = 20;

function getRouteInfo(
  event: EntityVisitedEvent,
  id: number,
): { to: string; navobj: Record<string, number> } {
  switch (event.type) {
    case 'article':
      return { to: 'article', navobj: { articleId: id } };
    case 'customer':
      return { to: 'customer', navobj: { customerId: id } };
    case 'concept':
      return { to: 'concept', navobj: { conceptId: id } };
    case 'supplier':
      return { to: 'supplier', navobj: { supplierId: id } };
    case 'inquiry':
      return {
        to: 'variant.inquiry.detail',
        navobj: { ...event.navobj, inquiryId: id },
      };
    case 'offer':
      return {
        to: 'variant.offers.group',
        navobj: { ...event.navobj, offerGroupId: id },
      };
  }
}

export interface HistoryEntry extends EntityVisitedEvent {
  to: string;
  navobj: Record<string, number>;
}

export function useEntityHistory() {
  const [history, setHistory] = useLocalStorage<HistoryEntry[]>(
    STORAGE_KEY,
    [],
  );

  useEffect(() => {
    return reactEvents.entityVisited.subscribe((event) => {
      const routeInfo = getRouteInfo(event, event.id);
      const entry: HistoryEntry = { ...event, ...routeInfo };
      setHistory((prev) => {
        const deduped = prev.filter(
          (e) => !(e.type === entry.type && e.id === entry.id),
        );
        return [entry, ...deduped].slice(0, MAX_ENTRIES);
      });
    });
  }, [setHistory]);

  return history;
}
